const {object, string} = require("yup");

export default ({assetsLimits = {}, assetsList = []}) => object({
  customer: string().required(),
  invoice: string().required(),
  company: string(),
  address: string(),
  expirationDate: string().test(
    'expirationDateMin',
    'Expiration date must always be in fututre',
    (value) => (
        new Date(value).getTime() > new Date().getTime()
    )
  ).required(),
  email: string().isValidEmail().required(),
  amount: string().test(
    'amount',
    'Min amount is {amount} {currency}',
    (value, ctx) => {
      const currency = (ctx.parent || {}).currency;
      const {
        min_amount = 0,
        max_amount = 0
      } = (assetsLimits[currency] || {});

      if (!!min_amount && Number(min_amount) > Number(value)) {
        return ctx.createError({message: `Min amount is ${min_amount} ${currency}`});
      }

      if (!!max_amount && Number(max_amount) < Number(value)) {
        return ctx.createError({message: `Max amount is ${max_amount} ${currency}`});
      }

      return true;
    }
  ).test(
    'amount',
    'Must be a positive number',
    (value) => Number(value) >= 0
  ).test(
    'amount',
    'Must be a number',
    (value) => !isNaN(value)
  ).required(),
  currency: string().oneOf(assetsList).required(),
  phone: string(),
  description: string().max(15000)
});
